import styled from 'styled-components';
import { modeColor } from '../../styles';
import { Box, type BoxProps } from '../Core';

export function PowerSearchEmpty({ children, ...props }: BoxProps) {
  return (
    <EmptyWrapper px="spacing16" py="spacing8" data-testid="power-search-empty" color="colorTextMuted" {...props}>
      {children}
    </EmptyWrapper>
  );
}

const EmptyWrapper = styled(Box)`
  border-top: 1px solid ${({ theme }) => modeColor(theme, theme.colors.black.mute, theme.colors.black.dim)};
`;
